//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TemplatesHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    backPath: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    containerSize: {
      type: String,
      default: "w-100"
    }
  },
  methods: {
    goBack() {
      if (!this.backPath) return;
      Amplitude.logEvent("Templates - go back clicked");
      this.$router.replace({
        path: this.backPath
      });
    }
  }
});